// Copyright (c) StrangeBee 2024

import client from '@Client';
import useDebounce from '@Hooks/useDebounce';
import React, { useState } from 'react';
import { THTagSelector, THTagSelectorProps } from './THTagSelector';

type AutocompleteProps = THTagSelectorProps;

export const Autocomplete = ({ value, onChange, options, taxonomies, ...props }: AutocompleteProps) => {
    const { debounce } = useDebounce();
    const [tags, setTags] = useState<string[]>([]);
    const [taxonomiesList, setTaxonomiesList] = useState<string[]>([]);

    const fetchTaxonomies = async (tag: string) => {
        const data = await client.TaxonomyController.list<string[]>({
            selector: {
                head: [{ name: 'tagAutoComplete', freeTag: tag, limit: 20 }],
                name: 'tags-auto-complete',
            },
        });
        setTaxonomiesList(data);
    };

    const fetchCustomTags = async (tag: string) => {
        const data = await client.CustomTagController.list<string[]>({
            selector: {
                head: [{ name: 'tagAutoComplete', freeTag: tag, limit: 20 }],
                name: 'tags-auto-complete',
            },
        });
        setTags(data);
    };

    return (
        <THTagSelector
            taxonomies={taxonomies}
            value={value}
            onSearch={(value) => {
                if (value?.length >= 3) {
                    debounce({
                        onTimeout: () => {
                            fetchCustomTags(value);
                            taxonomies && fetchTaxonomies(value);
                        },
                        timeoutDelay: 1000,
                    });
                }
            }}
            onChange={(value, options) => {
                onChange?.(value, options);
                setTags([]);
                setTaxonomiesList([]);
            }}
            options={[
                ...(options || []),
                ...(taxonomies
                    ? taxonomiesList.map((value) => ({ label: value, value }))
                    : tags.map((value) => ({ label: value, value }))),
            ]}
            {...props}
        />
    );
};
